import { AlertTriangle, RotateCw } from 'lucide-react'
import type { ReactNode } from 'react'
import { Button } from './Button'
import { EmptyState } from './EmptyState'
import { t } from '@/lib/i18n'

export interface ErrorStateProps {
  title?: ReactNode
  /** Error message, for example from ApiError.message. */
  message?: ReactNode
  /** Called by "Try again" (usually the query refetch). */
  onRetry?: () => void
  retrying?: boolean
  variant?: 'card' | 'plain'
  className?: string
}

/** Failure state with a retry button. */
export function ErrorState({
  title = t('Something went wrong'),
  message = t('We could not load this right now. Please try again.'),
  onRetry,
  retrying,
  variant,
  className,
}: ErrorStateProps) {
  return (
    <EmptyState
      icon={AlertTriangle}
      tone="danger"
      title={title}
      description={message}
      variant={variant}
      className={className}
      action={
        onRetry ? (
          <Button variant="secondary" onClick={onRetry} loading={retrying} leftIcon={<RotateCw />}>
            {t('Try again')}
          </Button>
        ) : undefined
      }
    />
  )
}
